import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <motion.footer 
      className="footer glass-card"
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>{t('footer.contact')}</h3>
            <div className="contact-info">
              <div className="contact-item">
                <Phone size={18} />
                <span>+33169047286</span>
              </div>
              <div className="contact-item">
                <MapPin size={18} />
                <span>{t('findUs.address')}</span>
              </div>
            </div>
          </div>


          <div className="footer-section">
            <div className="logo-footer">
              <img src="/images/Logo_Pacific1.png" alt="Pacific 91" className="logo-image-footer" />
              <p>{t('home.subtitle')}</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>{t('footer.rights')}</p>
          <div className="footer-links">
            <Link to="/legal" className="legal-link">
              {t('footer.legalMentions') || 'Mentions légales'}
            </Link>
            <span className="separator">•</span>
            <span className="made-by">
              <a
                href="https://pro.ody.app/"
                target="_blank"
                rel="noopener noreferrer"
                className="artemis-link"
              >
                Powered by ODY
              </a>
            </span>
          </div>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer; 